import { OrderedParallelEnumerable } from "../OrderedParallelEnumerable.js";
export const order = (source, comparer) => {
    return OrderedParallelEnumerable.generate(source, (x) => x, true, comparer);
};
